import { Button, Checkbox, FormLayout, Heading, Layout, Page, Stack, Subheading, TextField } from '@shopify/polaris';
import { useHistory } from 'react-router-dom';
import CustomerCreditCard from '../customers/CustomerCreditCard';
import {useCallback, useEffect, useState} from 'react';
import Api from '../../helpers/api';
import {CountrySelector, StateSelector} from "../Selectors";

export default function ({ customerId, setLocation, location, handleSubmit, errors, loading, setLoading, transferCredit = () => {} }) {
    const history = useHistory();
    const [customer, setCustomer] = useState(null);
    const [customerBilling, setCustomerBilling] = useState({
        address1: '',
        address2: '',
        address3: '',
        city: '',
        zip_code: '',
        state: '',
        country: '',
        type: '',
    });

    useEffect(() => {
        if (! customerId) {
            return;
        }
        setLoading(true);

        Api
            .getCustomer(customerId)
            .then( response => {
                setCustomer(response.data.data);

                if (!location.id) {
                    setCustomerBilling(response.data.data.default_location?.billing ?? location.billing ?? {
                        address1: '',
                        address2: '',
                        address3: '',
                        city: '',
                        zip_code: '',
                        state: '',
                        country: '',
                        type: '',
                    });
                }
            })
            .finally(() => setLoading(false));
    }, [customerId]);

    const handleChange = useCallback((key, value) => {
        if ( typeof value === 'boolean') {
            value = (value) ? 1 : 0;
        }

        const payload = {
            [key]: value,
        };

        if (key === 'practice_name') {
            payload.shipping = {
                ...location.shipping,
                address1: value,
            };
            payload.billing = {
                ...location.billing,
                address1: value,
            };
        }

        setLocation({
            ...location,
            ...payload,
        });
    }, [location]);

    const updateAddress = useCallback((type, key, value) => {
        setLocation({
            ...location,
            [type]: {
                ...location[type],
                [key]: value,
            },
        });
    }, [location]);

    const onLocationCardUpdate = (data) => {
        // If edit location - apply location; if not apply only credit_card_id
        setLocation(location.id
            ? data.location
            : {
                ...location,
                credit_card_id: data.card?.id,
                card: data.card,
            });
    }

    const secondaryActions = [
        location.id && {
            content: "Place Order",
            onAction: () => {
                history.push(`/orders/${customerId}?location_id=${location.id}`)
            }
        },
    ].filter(Boolean);

    const billingCheckboxChange = useCallback((newCheck) => {
        setLocation({
            ...location,
            billing: newCheck ?  customerBilling : null,
        });
    }, [location]);

    return (
        <Page
            title="Location"
            primaryAction={{
                content: 'Save',
                onAction: handleSubmit
            }}
            breadcrumbs={[
                { content: "Customer", onAction: () => {history.goBack()} }
            ]}
            secondaryActions={secondaryActions}
        >
            <Layout>
                <Layout.Section>
                    <FormLayout>
                        <CustomerCreditCard
                            customer={customer}
                            onUpdate={onLocationCardUpdate}
                            type="location"
                            card={location.card}
                            locationId={location.id}
                        />

                        <TextField disabled={loading} label="Phone Number" value={location.phone} onChange={(value) => {handleChange('phone', value)}} error={errors.phone}/>
                        <hr />
                        <Heading>Addresses</Heading>
                        <FormLayout.Group>
                            <Stack vertical>
                            </Stack>
                            <Stack vertical>
                                <Checkbox disabled={loading} checked={location.billing} onChange={billingCheckboxChange} label={"Add billing address"} />
                            </Stack>
                        </FormLayout.Group>
                        <FormLayout.Group>
                            <Stack vertical>
                                <Subheading>Shipping Address</Subheading>
                                <TextField disabled={loading} label="Company" value={location.shipping?.address1} onChange={(value) => {updateAddress('shipping', 'address1', value)}} error={errors['shipping.address1']}/>
                                <TextField disabled={loading} label="Address 1" value={location.shipping?.address2} onChange={(value) => {updateAddress('shipping', 'address2', value)}} error={errors['shipping.address2']}/>
                                <TextField disabled={loading} label="Address 2" value={location.shipping?.address3} onChange={(value) => {updateAddress('shipping', 'address3', value)}} error={errors['shipping.address3']}/>
                                <TextField disabled={loading} label="City" value={location.shipping?.city} onChange={(value) => {updateAddress('shipping', 'city', value)}} error={errors['shipping.city']}/>
                                <TextField disabled={loading} label="Zip Code" value={location.shipping?.zip_code} onChange={(value) => {updateAddress('shipping', 'zip_code', value)}} error={errors['shipping.zip_code']}/>

                                <CountrySelector disabled={loading} value={location.shipping?.country} onChange={(value) => {updateAddress('shipping', 'country', value)}} error={errors['shipping.country']}/>
                                <StateSelector disabled={loading} value={location.shipping?.state} onChange={(value) => {updateAddress('shipping', 'state', value)}} error={errors['shipping.state']} selectedCountry={location.shipping?.country} />
                            </Stack>
                            <Stack vertical>
                                { location.billing && (<Stack vertical>
                                    <Subheading>Billing Address</Subheading>
                                    <TextField disabled={loading} label="Company" value={location?.billing?.address1} onChange={(value) => {updateAddress('billing', 'address1', value)}} error={errors['billing.address1']}/>
                                    <TextField disabled={loading} label="Address 1" value={location?.billing?.address2} onChange={(value) => {updateAddress('billing', 'address2', value)}} error={errors['billing.address2']}/>
                                    <TextField disabled={loading} label="Address 2" value={location?.billing?.address3} onChange={(value) => {updateAddress('billing', 'address3', value)}} error={errors['billing.address3']}/>
                                    <TextField disabled={loading} label="City" value={location?.billing?.city} onChange={(value) => {updateAddress('billing', 'city', value)}} error={errors['billing.city']}/>
                                    <TextField disabled={loading} label="Zip Code" value={location?.billing?.zip_code} onChange={(value) => {updateAddress('billing', 'zip_code', value)}} error={errors['billing.zip_code']}/>

                                    <CountrySelector disabled={loading} value={location.billing?.country} onChange={(value) => {updateAddress('billing', 'country', value)}} error={errors['billing.country']}/>
                                    <StateSelector disabled={loading} value={location.billing?.state} onChange={(value) => {updateAddress('billing', 'state', value)}} error={errors['billing.state']} selectedCountry={location.billing?.country} />
                                </Stack>)}
                            </Stack>
                        </FormLayout.Group>

                        <hr />

                        <FormLayout.Group>
                            <TextField disabled={loading} label="Notes" value={location.notes} onChange={(value) => {handleChange('notes', value)}} type="text" id="notes" error={errors.notes} multiline={4} />
                        </FormLayout.Group>

                        <Checkbox disabled={loading} label="Set as Default Location" checked={location.default} onChange={(value) => {handleChange('default', value)}} />

                        <Button loading={loading} onClick={handleSubmit} primary>Save</Button>
                    </FormLayout>
                </Layout.Section>
            </Layout>
        </Page>
    )
}
